var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-rate"},_vm._l((_vm.total),function(n){return _c('span',{key:n,staticClass:"nut-rate-item",class:[{ 'nut-rate-active': n <= _vm.current }],style:({
      height: _vm.size + 'px',
      width: _vm.size + 'px',
      marginRight: _vm.spacing + 'px',
      backgroundImage: n <= _vm.current ? _vm.checkedIcon : _vm.uncheckedIcon
    }),on:{"click":function($event){return _vm.onClick($event, n)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }